import {Pipe, PipeTransform, SecurityContext} from "@angular/core";
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Pipe({
  standalone: false,
  name: 'sanitizeHtml'
})
export class SanitizeHtmlPipe implements PipeTransform {

  constructor(public _sanitizer:DomSanitizer) {
  }

  transform(v:string):SafeHtml {
    return this._sanitizer.sanitize(SecurityContext.HTML, v || '');
  }
}
